/**
 * DOM Utilities
 * HTML escaping and container initialization
 */

/**
 * Escape HTML to prevent XSS attacks
 * @param str - String to escape
 * @returns HTML-escaped string
 */
export function escapeHtml(str: string): string {
  if (typeof str !== 'string') return '';

  const htmlEscapes: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  };

  return str.replace(/[&<>"']/g, (char) => htmlEscapes[char] ?? char);
}

/**
 * Initialize container element from string selector or element
 * @param container - Container element or selector
 * @param errorMessage - Error message if container not found
 * @returns Resolved container element
 * @throws {Error} If container is not found
 */
export function initializeContainer(
  container: HTMLElement | string,
  errorMessage: string = 'Container not found'
): HTMLElement {
  let element: HTMLElement | null;

  if (typeof container === 'string') {
    element = document.querySelector(container);
  } else {
    element = container;
  }

  if (!element) {
    throw new Error(errorMessage);
  }

  return element;
}
